"use client";

import React from "react";
import CodUnpaidOrders from "../../../components/CodUnpaidOrders";

// Thin view wrapper that delegates to the shared CodUnpaidOrders component.
export default function CodUnpaidOrdersView(props) {
  return <CodUnpaidOrders {...props} />;
}
